import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Serializer, SerializerResponse} from '../interfaces/serializer';
import {map} from "rxjs/operators";
import {Path} from "../classes/path";
import {ConversionPathService} from "./conversion-path.service";
import {AdRequestParams} from '../interfaces/ad-reports';
import {Site} from '../interfaces/site';

@Injectable({
  providedIn: 'root'
})
export class ReportTransactionIdService {
  constructor(
    private readonly _http: HttpClient,
    private readonly _conversionPathS: ConversionPathService
  ) {
  }

  public generate(dataset: Serializer<Site>, params: Partial<AdRequestParams>, pageSize: number, page: number): Observable<{rows: Array<any>, total: number, transaction_ids: Array<string>}> {
    params['pageSize'] = pageSize;
    params['page'] = page;

    return this._http.post<SerializerResponse<any>>(`${environment.baseUrl}/api/${dataset.id}/reports/generate-transaction-id`,
      {
        parameters: params
      }
    ).pipe(
      map((response: SerializerResponse<any>) => {
        return this._formatResponse(response);
      })
    );
  }

  private _formatResponse(response: any): {rows: any[]; total: number; transaction_ids: Array<string>;} {
    const conversionPathGetters: any = {
      campaign: (chain, gran_infos) => {
        const found_campaign = Object.values(gran_infos).find((dim_infos) => {
          return dim_infos['is_campaign'];
        });
        return (found_campaign === undefined) ? undefined : found_campaign['value'];
      },
      channel: (chain) => chain.channel,
      percentage: (chain) => chain.percentages.percent / 100,
      gran: (chain) => chain.gran,
      revenue: (chain) => chain.percentages.revenu.formatted,
      date: (chain) => chain.date.formatted,
      device: (chain, gran_infos) => {
        const found_device = Object.values(gran_infos).find((dim_infos) => {
          return dim_infos['is_device'];
        });
        return (found_device === undefined) ? undefined : found_device['value'];
      },
    };

    for (const row of response.data) {
      row.days = parseInt(((row.chain_events[row.chain_events.length - 1].ts - row.chain_events[0].ts) / 86400).toFixed(0)) || 1;
      row.channel_conversion_path = this._conversionPathS.getConversionPath(row.chain_events, response.channels, response.dimensions_infos, 'channel', conversionPathGetters);
      row.campaign_conversion_path = this._conversionPathS.getConversionPath(row.chain_events, response.channels, response.dimensions_infos, 'campaign', conversionPathGetters);
      row.conversion_path = this._conversionPathS.getConversionPath(row.chain_events, response.channels, response.dimensions_infos, null, conversionPathGetters);
      row.details = this._getDetails(row.chain_events, row.conversion_path, response.dimensions_infos);
    }
    return {rows: response.data, total: response.total, transaction_ids: response.transaction_ids};
  }

  private _getDetails(chainEvents: Array<any>, conversionPath: Array<Path>, dimensions_infos: {}): Array<any> {
    const result: Array<any> = [];

    for (let i: number = 0; i < chainEvents.length; i++) {
      const metrics: Array<any> = [];
      const dimensions: Array<any> = [];

      for (const metric in chainEvents[i].presented_metrics) {
        metrics.push({
          name: metric,
          value: chainEvents[i].presented_metrics[metric]['$numberDecimal'] || chainEvents[i].presented_metrics[metric]
        });
      }

      const dimensions_infos_values = Object.values(dimensions_infos[chainEvents[i]['gran']])
      for (const dimension in dimensions_infos_values) {
        dimensions.push({
          name: dimensions_infos_values[dimension]['dimension_name'],
          value: dimensions_infos_values[dimension]['value']
        });
      }

      result.push({
        path: conversionPath[i],
        metrics: metrics,
        dimensions: dimensions
      });
    }

    return result;
  }
}
